import { render, staticRenderFns } from "./depoBank.vue?vue&type=template&id=75f2ddf3&scoped=true&"
import script from "./depoBank.vue?vue&type=script&lang=js&"
export * from "./depoBank.vue?vue&type=script&lang=js&"
import style0 from "./depoBank.vue?vue&type=style&index=0&id=75f2ddf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f2ddf3",
  null
  
)

export default component.exports